import { Outlet } from "react-router-dom";
import { useState } from "react";
import Header from "../common/Header";
import Sidebar from "./Components/Sidebar";
import "./DashboardLayout.css";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function DashboardLayout() {
  const [showSidebar, setShowSidebar] = useState(true);

  const toggleSidebar = () => setShowSidebar(!showSidebar);

  return (
    <div className="dashboardPage" dir="rtl">
      <Header />
      <div className="dashboard-body d-flex">
        <Sidebar className={showSidebar ? "" : "d-none d-lg-block"} />
        <div className="dashboard-content p-4 flex-grow-1">
          <Button
            variant="outline-secondary"
            onClick={toggleSidebar}
            className="mb-3 d-lg-none"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
